import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import combineStyles from '../../../../utils/combineStyles';
import TypographyStyles from '../../../../styles/typography';
import ButtonStyles from '../../../../styles/button';
import LayoutStyles from '../../../../styles/layout';
import { withNamespaces } from 'react-i18next';
import SpacingStyles from '../../../../styles/helpers/spacing';
import ProductStyles from './__styles__/Product.styles';
import OutlinedSelectInput from '../../../../components/Global/Inputs/OutlinedSelect';
import TextFieldInput from '../../../../components/Global/Inputs/TextField';
import CheckboxInput from '../../../../components/Global/Inputs/Checkbox';
import Button from '@material-ui/core/Button';
import ConfirmDialogModal from '../../../Global/Modals/ConfirmDialog';
import { FastField, Field } from 'formik';
import _get from 'lodash/get';
import _defaultsTo from 'lodash/defaultTo';
import Grid from '@material-ui/core/Grid';
import { DATATYPES } from '../../../../constants/constants';
import {
  UNIT_ABBREVIATIONS,
  CURRENCY_SYMBOL
} from '../../../../constants/constants';
import Hazmat from './Hazmat';
import { AppContext } from '../../../../AppProvider';
import Autocomplete from './../../../Global/Inputs/Autocomplete';
import { productSearch, fieldMapping } from './helpers';
import { withApollo } from 'react-apollo';
import GridItem from './../../../Global/GridItem';

export class Product extends Component {
  static propTypes = {
    productNumber: PropTypes.number.isRequired,
    unitNumber: PropTypes.number.isRequired,
    product: PropTypes.shape({
      product: PropTypes.shape({
        freightInfo: PropTypes.shape({
          freightClassId: PropTypes.string,
          nmfcItemCode: PropTypes.string,
          nmfcSubCode: PropTypes.string
        }),
        description: PropTypes.string,
        weightInfo: PropTypes.shape({
          weight: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        }),
        valueInfo: PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        })
      }),
      weightUnit: PropTypes.string,
      quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      isHazMat: PropTypes.bool
    }).isRequired,
    handleChange: PropTypes.func.isRequired,
    handleValidateField: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    contacts: PropTypes.array
  };
  constructor(props) {
    super(props);
    const productField = `handlingUnits[${props.unitNumber}].shipmentItems[${
      props.productNumber
    }]`;

    this.state = {
      openConfirmDeleteNotificationModal: false,
      SKU: _get(this.props, 'product.product.sku', null),
      productName: _get(this.props, 'product.product.name', null),
      productField,
      fieldNames: fieldMapping(productField)
    };
  }

  _handleOpenConfirmDeleteNotificationModal = () => {
    this.setState({ openConfirmDeleteNotificationModal: true });
  };

  _handleCloseConfirmDeleteNotificationModal = () => {
    this.setState({ openConfirmDeleteNotificationModal: false });
  };

  _handleRemoveProduct = () => {
    this.props.onRemove();
    this._handleCloseConfirmDeleteNotificationModal();
  };
  _getProductSuggestions = async value => {
    const { client: ApolloClient } = this.props;

    const suggestionResults = await productSearch(ApolloClient, value);
    const suggestions = suggestionResults.map(result => {
      return {
        label: `${result.sku} - ${result.name}`,
        data: { ...result }
      };
    });
    return Promise.resolve(suggestions);
  };
  _onProductFieldChanged = (field, change) => {
    this.setState({ [field]: change });
  };
  _onProductSelected = ({ data: product }) => {
    const { fieldNames } = this.state;
    const { setFieldValue } = this.props;

    this.setState({ SKU: product.sku, productName: product.name });
    setFieldValue(fieldNames.sku.fullPath, product.sku);
    setFieldValue(fieldNames.name.fullPath, product.name);
    setFieldValue(fieldNames.packageType.fullPath, product.packageTypeId);
    setFieldValue(
      fieldNames.description.fullPath,
      _defaultsTo(product.description, '')
    );
    setFieldValue(
      fieldNames.freightClass.fullPath,
      product.freightInfo.freightClassId
    );
    setFieldValue(
      fieldNames.nmfc.fullPath,
      _defaultsTo(product.freightInfo.nmfcItemCode, '')
    );
    setFieldValue(
      fieldNames.subcode.fullPath,
      _defaultsTo(product.freightInfo.nmfcSubCode, '')
    );
    setFieldValue(fieldNames.value.fullPath, product.valueInfo.value);
    setFieldValue(fieldNames.weight.fullPath, product.weightInfo.weight);
    setFieldValue(fieldNames.pieceCount.fullPath, product.pieceCount);
    setFieldValue(fieldNames.isHazMat.fullPath, product.isHazMat);
    //all hazmat fields
    const hazMat = product.hazMat;
    setFieldValue(
      fieldNames.contactFirstName.fullPath,
      hazMat.contactFirstName
    );
    setFieldValue(fieldNames.contactLastName.fullPath, hazMat.contactLastName);
    setFieldValue(fieldNames.contactPhone.fullPath, hazMat.contactPhone);
    setFieldValue(fieldNames.hazMatClassId.fullPath, hazMat.hazMatClassId);
    setFieldValue(
      fieldNames.hazMatPackingGroupId.fullPath,
      hazMat.hazMatPackingGroupId
    );
    setFieldValue(
      fieldNames.properShippingName.fullPath,
      hazMat.properShippingName
    );
    setFieldValue(fieldNames.unNumber.fullPath, hazMat.unNumber);
  };

  render() {
    const {
      productNumber,
      classes,
      t,
      product,
      handleChange,
      handleValidateField,
      unitNumber,
      contacts,
      setFieldValue
    } = this.props;
    const { SKU, productName, fieldNames } = this.state;
    const {
      referenceData: { freightClasses, packageTypes },
      orgInfo: {
        config: { defaultCurrency, defaultWeightUnit }
      }
    } = this.context.globalProps;
    const currencySymbol = defaultCurrency;
    const weightUnit = defaultWeightUnit;
    const isHazMat = _get(product, 'product.isHazMat', false);

    return (
      <Fragment>
        <div className={classnames(classes.subtitle3, classes.productTitle)}>
          <div className={classes.titleWrapper}>
            <h3 className={classnames(classes.subtitle3, classes.productTitle)}>
              {t('Product')} {productNumber + 1}
            </h3>
            <Button
              color="primary"
              className={classnames(classes.linkButton, classes.productAction)}
              classes={{
                label: classnames(classes.body2, classes.productActionLabel)
              }}
              onClick={this._handleOpenConfirmDeleteNotificationModal}
            >
              {t('REMOVE')}
            </Button>
          </div>
        </div>
        <Grid container spacing={16}>
          <GridItem lg={6}>
            <Field
              name={fieldNames.sku.fullPath}
              render={({ field, form }) => {
                return (
                  <Autocomplete
                    value={SKU || ''}
                    getSuggestions={this._getProductSuggestions}
                    getSuggestionValue={selected => selected.data.sku}
                    onSuggestionSelected={this._onProductSelected}
                    autoWidth={true}
                    label={t('SKU')}
                    onChange={change => {
                      this._onProductFieldChanged('SKU', change);
                      setFieldValue(fieldNames.sku.fullPath, change);
                    }}
                    field={field}
                    form={form}
                  />
                );
              }}
            />
          </GridItem>
          <GridItem lg={3}>
            <FastField
              value={_get(product, fieldNames.pieceCount.path, 0)}
              name={fieldNames.pieceCount.fullPath}
              label={t('Piece Count')}
              type="number"
              min={1}
              onChange={handleChange}
              component={TextFieldInput}
              validateField={handleValidateField}
            />
          </GridItem>
          <GridItem lg={3}>
            <FastField
              value={product.quantity}
              name={fieldNames.quantity}
              label={t('Qty')}
              type="number"
              min={1}
              onChange={handleChange}
              component={TextFieldInput}
              validateField={handleValidateField}
            />
          </GridItem>
          <GridItem lg={6}>
            <Field
              name={fieldNames.name.fullPath}
              render={({ field, form }) => {
                return (
                  <Autocomplete
                    value={productName || ''}
                    getSuggestions={this._getProductSuggestions}
                    getSuggestionValue={selected => selected.data.name}
                    onSuggestionSelected={this._onProductSelected}
                    autoWidth={true}
                    label={t('Name')}
                    onChange={change => {
                      this._onProductFieldChanged('productName', change);
                      setFieldValue(fieldNames.name.fullPath, change);
                    }}
                    field={field}
                    form={form}
                    validateField={handleValidateField}
                  />
                );
              }}
            />
          </GridItem>
          <GridItem lg={6}>
            <FastField
              value={_get(product, fieldNames.description.path, '')}
              name={fieldNames.description.fullPath}
              label={t('Description')}
              onChange={handleChange}
              component={TextFieldInput}
            />
          </GridItem>
          <GridItem lg={3}>
            <FastField
              name={fieldNames.freightClass.fullPath}
              onChange={handleChange}
              render={({ field, form }) => {
                return (
                  <OutlinedSelectInput
                    value={_get(product, fieldNames.freightClass.path, '')}
                    field={field}
                    form={form}
                    label={t('Class')}
                    options={freightClasses}
                    multiple={false}
                    validateField={handleValidateField}
                  />
                );
              }}
            />
          </GridItem>
          <GridItem lg={3}>
            <FastField
              value={_get(product, fieldNames.nmfc.path, '')}
              name={fieldNames.nmfc.fullPath}
              label={t('NMFC')}
              onChange={handleChange}
              component={TextFieldInput}
            />
          </GridItem>
          <GridItem lg={3}>
            <FastField
              value={_get(product, fieldNames.subcode.path, '')}
              name={fieldNames.subcode.fullPath}
              label={'Subcode'}
              onChange={handleChange}
              component={TextFieldInput}
            />
          </GridItem>
          <GridItem lg={3}>
            <FastField
              name={fieldNames.packageType.fullPath}
              onChange={handleChange}
              render={({ field, form }) => {
                return (
                  <OutlinedSelectInput
                    value={_get(product, fieldNames.packageType.path, null)}
                    field={field}
                    form={form}
                    label={t('Package Type')}
                    options={packageTypes}
                    multiple={false}
                    validateField={handleValidateField}
                  />
                );
              }}
            />
          </GridItem>
          <GridItem lg={3}>
            <FastField
              value={_get(product, fieldNames.weight.path, '')}
              name={fieldNames.weight.fullPath}
              label={t('Weight')}
              onChange={handleChange}
              component={TextFieldInput}
              endAdornment={UNIT_ABBREVIATIONS[weightUnit]}
              validateField={handleValidateField}
            />
          </GridItem>
          <GridItem item lg={3}>
            <FastField
              value={_get(product, fieldNames.value.path, '')}
              name={fieldNames.value.fullPath}
              label={t('Value')}
              onChange={handleChange}
              component={TextFieldInput}
              startAdornment={CURRENCY_SYMBOL[currencySymbol]}
              datatype={DATATYPES.NUMBER}
              validateField={handleValidateField}
            />
          </GridItem>
          <GridItem lg={6}>
            <div className={classes.hazMat}>
              <FastField
                name={fieldNames.isHazMat.fullPath}
                onChange={handleChange}
                render={({ field, form }) => (
                  <CheckboxInput
                    label={t('HazMat')}
                    field={field}
                    form={form}
                    value={_get(product, fieldNames.isHazMat.path, false)}
                    classes={{
                      root: classnames(classes.noMarginTop)
                    }}
                  />
                )}
              />
            </div>
          </GridItem>
          {isHazMat && (
            <Hazmat
              hazMat={_get(product, 'product.hazMat', {})}
              productNumber={productNumber}
              unitNumber={unitNumber}
              handleChange={handleChange}
              handleValidateField={handleValidateField}
              contacts={contacts}
              setFieldValue={setFieldValue}
            />
          )}
        </Grid>
        <ConfirmDialogModal
          open={this.state.openConfirmDeleteNotificationModal}
          title={t('Are you sure you want to remove this Product?')}
          message={`${t('Product')} ${productNumber + 1} ${t(
            'will no longer available.'
          )}`}
          confirmLabel={t('Delete')}
          onClose={this._handleCloseConfirmDeleteNotificationModal}
          onConfirm={this._handleRemoveProduct}
        />
      </Fragment>
    );
  }
}

Product.contextType = AppContext;
const translatedProduct = withNamespaces()(withApollo(Product));

export default withStyles(
  combineStyles(
    TypographyStyles,
    ButtonStyles,
    LayoutStyles,
    SpacingStyles,
    ProductStyles
  )
)(translatedProduct);
